import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

import { routes } from './app.routes';

const IlmzaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#dc2626',
      600: '#b91c1c',
      700: '#991b1b',
      800: '#7f1d1d',
      900: '#7f1d1d',
      950: '#450a0a'
    },
    colorScheme: {
      light: {
        primary: {
          color: '#b91c1c',
          contrastColor: '#ffffff',
          hoverColor: '#991b1b',
          activeColor: '#7f1d1d'
        },
        highlight: {
          background: '#fee2e2',
          focusBackground: '#fecaca',
          color: '#7f1d1d',
          focusColor: '#7f1d1d'
        }
      }
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'top' })
    ),
    providePrimeNG({
      theme: {
        preset: IlmzaPreset,
        options: {
          darkModeSelector: false,
          cssLayer: false
        }
      },
      ripple: true
    })
  ]
};
